module.exports = __webpack_public_path__ + "static/media/Landing-Page.ed6af965.mp4";